<template>
  <div class="ruleSetting-box">
    <div class="ruleLevel-btn-box">
      <div class="pull-right" :style="version == '0' ? 'visibility:hidden;' : ''">
        <button class="btn btn-style-add" @click="addLevel" :disabled="!enable || version == '0'">
          <span class="glyphicon glyphicon-plus"></span>
          {{multiLanguage.btnGroup.addLevel}}
        </button>
        <button class="btn btn-style-remove" @click="removeLevel" :disabled="!enable || version == '0'">
          <span class="glyphicon glyphicon-trash"></span>
          {{multiLanguage.btnGroup.removeLevel}}
        </button>
      </div>
      <div class="clear"></div>
    </div>
    <draggable :list="rule" v-model="newRelation" :options="{group:'levelGroup',disabled: onfocus}" @start="drag=true" @end="drag=false">
      <transition-group type="transition" :name="'flip-list'">
        <div class="rule-content-box panel panel-default" v-for="(levelItem,levelIndex) in rule" :key="levelIndex" :class="{'disabled' : !enable || version == '0'}">
          <div class="panel-heading title-bg">
            <div class="panel-title">
              <div class="pull-left">
                <label>
                  <input type="checkbox" :disabled="!enable || version == '0'" v-model="checkedLevel" :value="levelIndex" v-if="levelIndex !== rule.length-1" :style="version == '0' ? 'visibility:hidden;' : ''">
                  <span class="primary-color">
                    {{levelIndex == rule.length-1 ? ruleSettingLan.currentSetting : levelIndex+1 + ruleSettingLan.levelSetting}}
                    <span v-if="levelIndex == rule.length-1">
                      ({{currentIB.id + '-' + currentIB.name}})
                    </span>
                    <span v-else>
                      (
                        {{ newRelation[levelIndex].id !== 'not exist' ? newRelation[levelIndex].id + '-' + (newRelation[levelIndex].name === 'not exist' ? ruleSettingLan.notSalesSet : newRelation[levelIndex].name) : ruleSettingLan.notExist }}
                      )
                    </span>
                  </span>
                </label>
              </div>
              <div class="pull-right" :style="version == '0' ? 'visibility:hidden;' : ''">
                <button class="btn btn-style-add" :disabled="!enable || version == '0'" @click="addRule(levelItem)">
                  <span class="glyphicon glyphicon-plus"></span>
                  {{ruleSettingLan.addRule}}
                </button>
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <draggable :list="levelItem" :options="{group:'ruleGroup',disabled: onfocus}" @start="drag=true" @end="drag=false">
            <transition-group type="transition" :name="'flip-list'">
              <div class="panel-body" v-for="(ruleItem,ruleIndex) in levelItem" :key="ruleIndex">
                <div class="rule-title">
                  <div class="pull-left primary-color">{{ruleSettingLan.rule}}{{ruleIndex+1}}</div>
                  <div class="pull-right" :style="version == '0' ? 'visibility:hidden;' : ''">
                    <button class="btn btn-xs" :disabled="!enable || version == '0'" @click="removeRule(levelItem,ruleIndex)">
                      <span class="glyphicon glyphicon-trash"></span>
                    </button>
                  </div>
                  <div class="clear"></div>
                </div>
                <div class="rule-content" >
                  <div class="form-horizontal" :class="{'row' : viewBtn=='onlyOne'}">
                    <div class="form-group" :class="{'col-sm-6' : viewBtn=='onlyOne'}">
                      <div class="col-sm-6">
                        <label class="radio-inline">
                          <input type="radio" :name="version+'_'+levelIndex+'_'+ruleIndex+'_'+'enableCommTarget'"
                            :disabled="!enable || version == '0'"
                            :value="false"
                            v-model="ruleItem.enableCommTarget"
                          >
                          {{ruleSettingLan.toOriginalAccount}}
                        </label>
                        <label class="radio-inline">
                          <input type="radio" :name="version+'_'+levelIndex+'_'+ruleIndex+'_'+'enableCommTarget'"
                            :disabled="!enable || version == '0'"
                            :value="true"
                            v-model="ruleItem.enableCommTarget"
                          >
                          {{ruleSettingLan.toTargetAccount}}
                        </label>
                      </div>
                      <label class="col-sm-6">
                        <input type="text" class="form-control" v-model="ruleItem.commTarget"
                          :disabled="!enable || version == '0' || !ruleItem.enableCommTarget"
                          v-validate="'required|numeric'"
                          :name="levelIndex+'_'+ruleIndex+'_'+'commTarget'"
                          :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'commTarget') ? 'border-color:#f44336;' : ''"
                          @focus="onfocus=true" @blur="onfocus=false"
                          @change="checkId(ruleItem)"
                        >
                      </label>
                    </div>
                  </div>
                  <div class="form-inline" :class="{'col-sm-6 row' : viewBtn=='onlyOne'}">
                    <div class="form-group">
                      <label class="radio-inline flex-item-left">
                        <input type="radio" :name="version+'_'+levelIndex+'_'+ruleIndex+'_'+'ruleId'"
                          :disabled="!enable || version == '0'"
                          :value="0"
                          checked
                        >
                        {{ruleSettingLan.customTheMoney}}
                      </label>
                    </div>
                    <div class="form-group">
                      <div class="input-group">
                        <select class="form-control" :disabled="!enable || version == '0'"
                          v-model="ruleItem.ruleId"
                          v-validate="'required'"
                          :name="levelIndex+'_'+ruleIndex+'_'+'ruleId'"
                          :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'ruleId') ? 'border-color:#f44336;' : ''"
                        >
                          <option :value="ruleSeqItem.ruleId" v-for="(ruleSeqItem,ruleSeqIndex) in ruleSeq">
                            {{publicLan.rule[ruleSeqItem.langKey.split('.')[1]]}}
                          </option>
                        </select>
                        <span class="input-group-addon">
                          <el-tooltip class="item" effect="dark" placement="top-start"
                            :disabled="!enable || version == '0'"
                          >
                            <span class="glyphicon glyphicon-tags"></span>
                            <div slot="content" style="width: 180px;line-height:20px;" v-for="(ruleSeqItem,ruleSeqIndex) in ruleSeq" v-if="ruleSeqItem.ruleId === ruleItem.ruleId">
                                {{ publicLan.rule[ruleSeqItem.descLangKey.split('.')[1]] }}
                            </div>
                          </el-tooltip>
                        </span>
                      </div>
                    </div>
                    <div class="form-group">
                      <input type="text" class="form-control" style="border-radius:3px"
                          :disabled="!enable || version == '0'"
                          v-model="ruleItem.value"
                          v-validate="'required|min_value:0.0001|decimal:4'"
                          :name="levelIndex+'_'+ruleIndex+'_'+'value1'"
                          :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'value1') ? 'border-color:#f44336;' : ''"
                          @focus="onfocus=true" @blur="onfocus=false"
                        >
                    </div>
                    <div class="form-group">
                      <select class="form-control" :disabled="!enable || version == '0'"
                        v-model="ruleItem.clientType"
                        v-validate="'required'"
                        :name="levelIndex+'_'+ruleIndex+'_'+'clientType'"
                        :style="errors.has(levelIndex+'_'+ruleIndex+'_'+'clientType') ? 'border-color:#f44336;' : ''"
                      >
                        <option :value="0">{{publicLan.clientType.allClient}}</option>
                        <option :value="1">{{publicLan.clientType.IBClient}}</option>
                        <option :value="2">{{publicLan.clientType.directClient}}</option>
                      </select>
                    </div>
                  </div>
                  <div class="clear"></div>
                </div>
              </div>
            </transition-group>
          </draggable>
        </div>
      </transition-group>
    </draggable>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  export default {
    components: {
      draggable,
    },
    mixins: [
      require("common/mixin/base.js").base({ruleSettingLan:"ruleItem"}),
      require("common/mixin/base.js").base({publicLan:"publicLan"})
    ],
    props: {
      viewBtn: {
        type: String,
        default: '',
      },
      enable: {
        type: Boolean,
        default: false,
      },
      multiLanguage: {
        type: Object,
        default: {},
      },
      version: {
        type: String,
        default:　'',
      },
      relation: {
        type: Array,
        default: [],
      },
      currentIB: {
        type: Object,
        default: {},
      },
      rule: {
        type: Array,
        default: [],
      },
      ruleSeq: {
        type: Array,
        default: [],
      },
    },
    data () {
      return{
        checkedLevel: [],
        onfocus: false,
      }
    },
    computed: {
      newRelation () {
        let arr = [] // 最后返回的数组
        let len = this.rule.length-1 // 因为最后一个当前自己，不需要，所有重倒数第二个开始截取数组
        let num = this.rule.length - this.relation.length // rule 和 relation 的长度差值
        if (num <= 1) arr = this.relation.slice(len*-1) // 根据rule的长度截取出新的relation数组，因为rule最后一个必定是自己，所以判断结果时要从 两者长度差值小于等于1 的值开始截取
        else{ // 否则，当rule的长度于relation的长度差值 大于1时，
          arr = this.relation.concat([]) // 先复制一份完整的relation給arr
          for(let i=0;i<num-1;i++){ // 然后根据 rule的长度减去relation的长度的差值来循环添加 not exist，因为两者差值在这里已经是大于1的值，所以要减去1才能得出正确的循环次数，
            arr.unshift({name:'not exist',id: 'not exist'}) // 代码到这里，表示所有的关系都已经添加了，之后添加的rule级别都是不在关系图里面的， 所以我用not exist 表示不存在
          }
        }
        return arr
      }
    },
    methods: {
      addLevel () { // 添加级别
        this.rule.unshift([
          {
            ruleId: 4,
            clientType: 0,
            value: '',
            enableCommTarget: false,
            commTarget: ''
          }
        ])
      },
      removeLevel () { // 删除级别
        if (this.checkedLevel.length > 0) {
          let msg = this.multiLanguage.btnGroup.confirmDeleteText
          if (confirm(msg) == true) {
            if (this.rule.length - this.checkedLevel.length >= 1) {
              let tem = this.rule.concat([])
              this.checkedLevel.forEach(item => {
                delete tem[item]
              })
              this.$parent.rule = tem.filter(item => item != null)
              this.checkedLevel = []
            }
            else return
          }
        }
        else return
      },
      addRule (levelItem) { // 添加规则
        levelItem.push({
            ruleId: 4,
            clientType: 0,
            value: '',
            enableCommTarget: false,
            commTarget: ''
        })
      },
      removeRule (levelItem,ruleIndex) { // 删除规则
        let msg = this.multiLanguage.btnGroup.confirmDeleteText
        if (confirm(msg) == true) {
          levelItem.splice(ruleIndex,1)
        }
      },
      checkId (ruleItem) {
        this.$emit('checkId',ruleItem)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ruleSetting-box{
    .ruleLevel-btn-box{
      margin: 10px 0;
    }
    .glyphicon{
      font-size: 12px;
    }
    input[type='checkbox'] {
      width: 20px;
      height: 20px;
      vertical-align: middle;
      margin-top: 0;
    }
    .rule-content-box{
      .panel-title{
        height: 36px;
        line-height: 36px;
      }
      .panel-body{
        padding: 0;
        .rule-title{
          border-bottom: 1px solid #bbb;
          padding: 10px 20px;
          line-height: 30px;
          button{
            background: transparent;
            span{
              color: #f08712;
            }
          }

        }
        .rule-content{
          padding: 20px;
          .form-horizontal,.form-inline{
            white-space: nowrap;
            // overflow-x: auto;
          }
          .tips-wrap{
            position: relative;
            .tips-box{
              width: 120px;
              line-height: 30px;
              background: #000;
              color: #fff;
              border-radius: 3px;
              z-index: 999;
            }
          }

        }
      }
    }
    .primary-color{
      color: #3f51b5;
    }
    .title-bg{
      background-color: #EBEDF7;
    }
    .btn-style-add {
      background-color: #3f51b5;
      color:#fff;
    }
    .btn-style-remove {
      background-color:#f08712;
      color:#fff;
    }
  }
</style>







// WEBPACK FOOTER //
// ruleSetting.vue?11309c37